var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[(_vm.error)?_c('error-banner',{attrs:{"message":_vm.error}}):_vm._e(),_vm._l((_vm.petCaches),function(pet,index){return _c('pet-details',{key:pet.id,attrs:{"pet-index":index}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }